// extracted by mini-css-extract-plugin
export var actionSelect = "_sp-0";